export const BUSINESS_LINES = [
	{ id: 'core', translation: 'کور' },
	{ id: 'offline_cash_back', translation: 'آفلاین کش‌بک' },
	{ id: 'online_cash_back', translation: ' آنلاین کش‌بک' },
	{ id: 'offline_cash_back_and_core', translation: 'کور+آفلاین کش‌بک' },
	{ id: 'boosting', translation: 'بوستینگ' },
];

export const setLocalStorageBusinessLine = (businessLine) =>
	localStorage.setItem('businessLine_name', businessLine);
